export default __webpack_public_path__ + "media/pdfs/widerrufsformular_crowdis_gmbh-31900d0c5734c0be7ef506260e65ed93.pdf";